import { z } from 'zod';

const serviceAgreementPartySchema = z.object({
  id: z.string(),
  name: z.string(),
});

const companyUserRoleSchema = z.enum(['ACCOUNTHOLDER', 'ADMIN', 'FINANCE', 'HQADMIN']);

export const supplierWorkTargetSchema = z.object({
  companyId: z.string(),
  name: z.string(),
  companyType: z.enum(['LIMITED', 'FULL']),
  offersFreelanceWork: z.boolean(),
  offersTempWork: z.boolean(),
  offersEmployeeWork: z.boolean(),
});

export const supplierWorkTargetsSchema = z.array(supplierWorkTargetSchema);

export type SupplierWorkTarget = z.infer<typeof supplierWorkTargetSchema>;

export const serviceAgreementCompanySchema = z.object({
  serviceAgreement: z.object({
    id: z.string(),
    serviceAgreementPartyRole: z.enum(['LENDER', 'BORROWER']),
    lenderServiceAgreementParty: serviceAgreementPartySchema,
    borrowerServiceAgreementParty: serviceAgreementPartySchema,
    workerPoolSize: z.number(),
    flexPoolCount: z.number(),
    state: z.enum(['PENDING', 'ACCEPTED', 'REJECTED', 'TERMINATED']),
    allowDirectPlanning: z.boolean(),
  }),
  company: z.object({
    id: z.string(),
    name: z.string(),
    cocNumber: z.string().nullable(),
    address: z.string().nullable(),
    invoiceEmail: z.string().nullable(),
    profileImageUrl: z.string().nullable(),
  }),
  users: z.array(
    z.object({
      id: z.string(),
      firstName: z.string(),
      lastName: z.string(),
      phone: z.string(),
      email: z.string(),
      role: companyUserRoleSchema.nullable(),
    })
  ),
});

export type ServiceAgreementCompany = z.infer<typeof serviceAgreementCompanySchema>;
